/**
 * SXTNotificationBell - to display bell and number of notifications to user
 *
 * @version 1.0.1
 * @author [Karthick Shanmugam](https://github.com/karthickShanmugam0689)
 */
import * as React from 'react'
import {compose, withApollo} from 'react-apollo'
import NotificationCountBadge from '../NotificationCountBadge/NotificationCountBadge'
const SXTNotificationBell = ({count}) => {
  return <NotificationCountBadge count={count} />
}

export default React.memo(compose(withApollo)(SXTNotificationBell))
